import {ExError,ErrorType} from './error';

export class TypeError implements ExError{        
    name:string;
    message:string; 
    data:any; 
	constructor(name:string,message:string,data:any) {		
		this.name = name;
        this.message = message;                
        this.data = data;
	}
}


// WEBPACK FOOTER //
// ./src/app/error/type-error.ts